import Api from '../api';

export default class NavigationApi extends Api {
  getNavigationMenus = async () => {
    try {
      const apiData = await this.get(`userPreferences/menu`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get navigation data.'
      };
    }
  };

  getAvailableNavigationMenus = async () => {
    try {
      const apiData = await this.get(`/menu?isLoadAllMenus=true`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get navigation data.'
      };
    }
  };

  getFeatureMenus = async () => {
    try {
      const apiData = await this.get(`/features`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get Feature menu data.'
      };
    }
  };

  updateLocaleCall = async queryParams => {
    try {
      const apiData = await this.put(`locale/default?locale=${queryParams}`);
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to update language.'
      };
    }
  };
}
